import { apiRequest } from '../client';
import type { PageResponse } from '../types';

/**
 * Address / attributes are open-shape blobs — the backend stores them as
 * JSONB. For MVP we type them as generic maps; the metadata engine describes
 * the actual schema per pilot.
 */
export type JsonObject = Record<string, unknown>;

export interface CustomerView {
  id: string;
  code: string;
  name: string;
  taxId: string | null;
  email: string | null;
  phone: string | null;
  address: JsonObject | null;
  /** Decimal serialized as string over the wire — parse before math. */
  perWhRate: string;
  currency: string;
  attributes: JsonObject | null;
  active: boolean;
  createdAt: string;
}

export interface CustomerSummary {
  id: string;
  code: string;
  name: string;
  perWhRate: string;
  currency: string;
  active: boolean;
}

export interface CreateCustomerRequest {
  name: string;
  taxId?: string;
  email?: string;
  phone?: string;
  address?: JsonObject;
  perWhRate: string;
  currency: string;
  attributes?: JsonObject;
}

export interface UpdateCustomerRequest {
  name: string;
  taxId?: string;
  email?: string;
  phone?: string;
  address?: JsonObject;
  perWhRate: string;
  currency: string;
  attributes?: JsonObject;
  active: boolean;
}

export const customersApi = {
  list: (page = 0, size = 20) =>
    apiRequest<PageResponse<CustomerView>>(
      `/api/customers?page=${page}&size=${size}`
    ),

  summaries: (page = 0, size = 20) =>
    apiRequest<PageResponse<CustomerSummary>>(
      `/api/customers/summaries?page=${page}&size=${size}`
    ),

  get: (id: string) => apiRequest<CustomerView>(`/api/customers/${id}`),

  create: (request: CreateCustomerRequest) =>
    apiRequest<CustomerView>('/api/customers', {
      method: 'POST',
      body: request
    }),

  update: (id: string, request: UpdateCustomerRequest) =>
    apiRequest<CustomerView>(`/api/customers/${id}`, {
      method: 'PUT',
      body: request
    })
};
